import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      d: "M15.607 16.785c-4.205-.6-7.71-4.005-8.31-8.31-.3-2.303.2-4.405 1.202-6.207.5-.902-.4-1.803-1.302-1.402C3.092 2.968.389 7.374.789 12.28c.4 5.707 5.207 10.512 10.913 10.913 5.007.4 9.412-2.303 11.414-6.408.5-.901-.5-1.802-1.401-1.302-1.703 1.102-3.905 1.602-6.108 1.302"
    }, null, -1)
  ]));
}
const interfaceWeatherMoon = { render };
export {
  interfaceWeatherMoon as default,
  render
};
//# sourceMappingURL=interface-weather-moon.svg.js.map
